/* eslint no-shadow: ["error", { "allow": ["SubscriptionPackages"] }] */

enum SubscriptionPackages {
  Bronze = 'bronze',
  Silver = 'silver',
  Gold = 'gold',
}

export default SubscriptionPackages;
